export enum ToolPropertyValidationState {
    Valid = 'Valid',
    Info = 'Info',
    Error = 'Error'
}
